import { FC } from 'react';
import { useHistory } from 'react-router';
import { Image, Spacer, VStack } from '@chakra-ui/react';

import { TransactionFeeType } from '__generated__/GQL';
import okHandImg from 'assets/brand/ok-hand@2x.png';
import { getFixedFeeForType } from 'common/fees';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';

import SidebarFooter from '../../../components/SidebarFooter';
import NavigationHeader from '../../NavigationHeader';
import locales from './locales';
import { removeNonPrintableChars } from './utils';

interface ActivationSuccessProps {
  creditCardId: string;
  pin: string | null;
}

const ActivationSuccess: FC<ActivationSuccessProps> = ({
  creditCardId,
  pin,
}) => {
  const history = useHistory();

  const warnings = [
    pin
      ? (locales.formatString(
          locales.changePinInfo,
          getFixedFeeForType(TransactionFeeType.CardAtmEuro),
        ) as string)
      : locales.noPinInfo,
  ];

  return (
    <>
      <NavigationHeader />

      <Image
        alt=""
        boxSize="90px"
        marginBottom="space-16"
        role="presentation"
        src={okHandImg}
      />

      <VStack alignItems="flex-start" gap="space-8" marginBottom="space-24">
        <Heading>{pin ? locales.pinLabel : locales.noPinLabel}</Heading>

        {pin ? (
          <Heading color="text-secondary" size="xl">
            {removeNonPrintableChars(pin)}
          </Heading>
        ) : null}
      </VStack>

      <Callout hideIcon>
        <Callout.Content>{warnings[0]}</Callout.Content>
      </Callout>

      <Spacer />

      <SidebarFooter>
        <Button
          onClick={() => history.push(`/cards/${creditCardId}`)}
          width="100%"
        >
          {locales.continue}
        </Button>
      </SidebarFooter>
    </>
  );
};

export default ActivationSuccess;
